import { render, staticRenderFns } from "./NoContactsModal.vue?vue&type=template&id=749beaed&"
import script from "./NoContactsModal.vue?vue&type=script&lang=js&"
export * from "./NoContactsModal.vue?vue&type=script&lang=js&"
import style0 from "./NoContactsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports